import React from "react";

// Chakra imports
import { Flex, useColorModeValue, Image } from "@chakra-ui/react";

// Custom components
import { DashboardLogo } from "components/icons/Icons";
import logo from "assets/img/auth/gemhsmed.png";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      {/* <DashboardLogo h='40px' w='180px' my='32px' color={logoColor} /> */}
      <Image src={logo} h={40} w={60} my='32px'/>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
